import { pdfjs } from 'react-pdf';

// Worker is pre-loaded as a <script> tag in index.html (window.pdfjsWorker).
// This allows pdfjs to fall back to main-thread processing on devices
// that cannot create Web Workers (e.g. WebView 91 on T95Max Android box).
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';
